import React from 'react';
import './FloatingPhone.css';
import { FaPhone } from 'react-icons/fa';

const FloatingPhone = () => {
  const handlePhoneClick = () => {
    // Check if it's a mobile device
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      window.location.href = 'tel:+919890826344';
    }
  };

  return (
    <div className="floating-phone" onClick={handlePhoneClick}>
      <FaPhone className="phone-icon" />
    </div>
  );
};

export default FloatingPhone;
